import React from 'react'
import Logo from '../../images/AboutBanner.jpg'
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";


const slideIn = {
  visible: { opacity: 1, translateX: 0 },
  hidden: { opacity: 0, translateX: -100 },
};

const AboutBanner = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <motion.div
        ref={ref}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
        variants={slideIn}
        transition={{ duration: 0.5, ease: "easeIn" }}
        className='max-w-[1400px] px-2 py-10'>
          <img src={Logo} alt="Members photo" className='bg-cover'/>
    </motion.div>
  )
}

export default AboutBanner